<template>
  <div>
    <ModalDialog v-model="isShow" :width="90" :level="3">
      <div
        class="p-5 field-of-fields input-dialog-container"
        slot="dialog-content"
      >
        <h3 v-if="title" class="dialog-title">{{ title }}</h3>
        <h4 class="description" v-if="description">{{ description }}</h4>
        <hr
          v-if="title && !hideHr"
          :style="hasDistanceTop ? null : 'margin-bottom: 0'"
        />
        <slot name="custom-field" />
        <FormGroupRowLayout
          :listFields="listFields"
          :modelData="applicationData"
          :tagData="tagData"
          :submitClicked="submitClicked"
          @changed="handleChange"
        >
          <template v-for="(field, index) of listFields">
            <div
              :key="'field-' + index"
              v-if="field.slotTag"
              :slot="field.slotTag"
            >
              <button type="button" @click="handleShowInsertTagDialog(field)">
                Insert Tag
              </button>
            </div>
          </template>
        </FormGroupRowLayout>
        <slot name="custom-map-fields" />
        <hr />
        <div class="button-container">
          <button
            type="button"
            class="mylisting-button secondary-button cancel-button"
            @click="hideModal()"
          >
            {{ getLabelByKeys("BUTTONS.CANCEL") }}
          </button>
          <slot name="custom-buttons" />
          <button
            v-if="isShowSubmitButton"
            type="button"
            class="mylisting-button dark-button"
            style="float: right"
            :disabled="isRecordingVideo"
            @click="handleSubmit()"
          >
            {{ submitButton }}
          </button>
        </div>
      </div>
    </ModalDialog>
    <InputDialog
      v-if="title !== 'Input Tag Information'"
      v-model="isShowTagInputDialog"
      title="Input Tag Information"
      :listFields="listFieldsInputTag"
      @submit="handleInsertTag($event)"
    />
  </div>
</template>
<script>
/* 
This dialog is used to get input from user for some simple form.
For example: a dialog contains a textbox, user fill in the textbox, then click Submit button
 */
import { FORM_TYPE } from "../../constants/custom-define-type";
import VSwatches from "vue-swatches";
import MultiSelect from "./complex-input-elements/MultiSelect.vue";
import ModalDialog from "./global-dialogs/ModalDialog.vue";
import FileUpload from "./form-elements/FileUpload.vue";
import { mapGetters } from "vuex";

export default {
  name: "InputDialog",
  props: {
    // Status of dialog: Open, close
    value: Boolean,
    description: String,
    listFields: Array,
    isShowSubmitButton: {
      type: Boolean,
      default: true,
    },
    submitButton: {
      type: String,
      default: "Submit",
    },
    title: String,
    initialValue: Object,
    ignoreAgentMissing: {
      type: Boolean,
      default: false,
    },
    listTagFields: Array,
    // Tag data which is used to replace tag in form element (for example: Checkbox option)
    tagData: Object,
    closeOnSubmit: {
      type: Boolean,
      default: true,
    },
    hideHr: {
      type: Boolean,
      default: false,
    },
    hasDistanceTop: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VSwatches,
    MultiSelect,
    ModalDialog,
    FileUpload,
  },
  data() {
    return {
      FORM_TYPE: FORM_TYPE,
      applicationData: {},
      isShow: false,
      submitClicked: false,
      selectedField: null,
      isShowTagInputDialog: false,
    };
  },
  computed: {
    ...mapGetters(["isRecordingVideo"]),
    listFieldsInputTag() {
      if (!this.listTagFields || !this.listTagFields.length) {
        return [];
      }
      return [
        {
          label: "Tag field",
          model: "model",
          type: FORM_TYPE.MULTI_SELECT,
          optionList: this.listTagFields,
          optionLabel: "label",
          optionModel: "model",
        },
      ];
    },
  },
  methods: {
    setApplicationData(data) {
      this.applicationData = { ...data };
    },
    handleChange(selectedFieldsData) {
      this.$emit("changed", selectedFieldsData);
    },
    hideModal() {
      this.isShow = false;
      this.$emit("input", false);
    },
    showModal() {
      this.isShow = true;
    },
    handleSubmit() {
      this.submitClicked = true;
      if (
        this.hasInvalidField(
          this.applicationData,
          this.listFields,
          this.$store.getters.isAgent && this.ignoreAgentMissing
        )
      ) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
        return;
      } else {
        this.$emit("submit", this.applicationData);
        if (this.closeOnSubmit) {
          this.hideModal();
        }
      }
    },
    handleShowInsertTagDialog(field) {
      this.selectedField = field;
      this.isShowTagInputDialog = true;
    },
    handleInsertTag(info) {
      const fieldModel = this.selectedField.model;
      if (!this.applicationData[fieldModel]) {
        this.applicationData[fieldModel] = "";
      }
      this.applicationData[fieldModel] += `[[${info.model}]]`;
      this.applicationData = JSON.parse(JSON.stringify(this.applicationData));
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (value === true) {
          this.submitClicked = false;
          if (this.initialValue) {
            this.applicationData = Object.assign({}, this.initialValue);
          }
          this.showModal();
        } else {
          this.hideModal();
        }
      },
    },
    isShow: {
      immediate: true,
      handler() {
        this.$emit("input", this.isShow);
      },
    },
  },
};
</script>
<style scoped>
.input-dialog-container {
  text-align: left;
  line-height: 1.5;
}

.label-input-dialog {
  margin-top: 0;
}

.checkbox-element {
  margin-left: 20px;
  margin-top: 0.5em;
}

.color-picker-container {
  display: flex;
  align-items: center;
}

.color-picker-label > label {
  margin-top: 0;
  margin-bottom: 0;
}

.color-picker-label {
  flex-basis: 33em;
}

.description {
  font-size: 1.2em;
}
</style>


// WEBPACK FOOTER //
// src/components/common/InputDialog.vue